export default __webpack_public_path__ + "static/media/img-34-tovenaar.246ae772.jpg";